import { render, staticRenderFns } from "./TelegramLogin.vue?vue&type=template&id=7da73b06&"
import script from "./TelegramLogin.vue?vue&type=script&lang=js&"
export * from "./TelegramLogin.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports